// Segment CRUD Reducer
// Handles flight segment creation, updates, and deletion

import type { ClaimState, ClaimAction, FlightSegment } from './types';
import { toEditableSegments, createNewSegment } from './types';

export function segmentReducer(state: ClaimState, action: ClaimAction): ClaimState | null {
  switch (action.type) {
    case 'SET_EXTRACTED_DATA':
      return {
        ...state,
        extractedData: action.data,
        editableSegments: toEditableSegments(action.data.flight_segments),
        pnr: action.data.pnr,
        bookingDate: action.data.booking_date || null,
        isDirty: true,
      };

    case 'UPDATE_SEGMENTS':
      return {
        ...state,
        editableSegments: action.segments,
        isDirty: true,
      };

    case 'UPDATE_SEGMENT':
      return {
        ...state,
        editableSegments: state.editableSegments.map((seg) =>
          seg._id === action.id ? { ...seg, [action.field]: action.value } : seg
        ),
        isDirty: true,
      };

    case 'ADD_SEGMENT':
      return {
        ...state,
        editableSegments: [...state.editableSegments, createNewSegment()],
        isDirty: true,
      };

    case 'DELETE_SEGMENT':
      return {
        ...state,
        editableSegments: state.editableSegments.filter(
          (seg) => seg._id !== action.id
        ),
        isDirty: true,
      };

    case 'SET_PNR':
      return {
        ...state,
        pnr: action.pnr,
        isDirty: true,
      };

    default:
      return null;
  }
}
